import React from 'react';
import { SkeletonTitleBar } from 'app/client/components/OverviewSkeleton';
import * as S from '../../styled';

// Two placeholder groups of three rows each, with varied bar widths so the
// skeleton reads as "results" rather than a uniform grid. The bars use
// SkeletonTitleBar (absolutely positioned inside a natural line box), so group
// titles and row text keep their exact text height — no shift when real
// results replace them.
const GROUPS = [
  {
    key: 'group-1',
    titleWidth: '90px',
    rows: [
      { title: '180px', subtitle: '120px' },
      { title: '140px', subtitle: '90px' },
      { title: '220px', subtitle: '110px' },
    ],
  },
  {
    key: 'group-2',
    titleWidth: '70px',
    rows: [
      { title: '160px', subtitle: '100px' },
      { title: '200px', subtitle: '80px' },
      { title: '130px', subtitle: '120px' },
    ],
  },
];

/**
 * The loading placeholder for the global-search results area, shown while a
 * search is in flight and there are no previous results to keep on screen.
 * Reuses the real Group/GroupTitle/GroupList/Row chrome so it matches the
 * loaded layout by construction.
 *
 * @returns {Element} The rendered skeleton.
 */
const Skeleton = () => (
  <div aria-hidden>
    {GROUPS.map((group) => (
      <S.Group key={group.key}>
        <S.GroupTitle>
          <SkeletonTitleBar width={group.titleWidth} />
        </S.GroupTitle>

        <S.GroupList>
          {group.rows.map((row) => (
            <S.SkeletonRow key={`${group.key}-${row.title}-${row.subtitle}`}>
              <S.RowLeft>
                <S.RowIcon>
                  <S.SkeletonIcon effect="sheen" />
                </S.RowIcon>

                <S.RowText>
                  <S.RowTitle>
                    <SkeletonTitleBar width={row.title} />
                  </S.RowTitle>
                  <S.RowSubtitle>
                    <SkeletonTitleBar width={row.subtitle} />
                  </S.RowSubtitle>
                </S.RowText>
              </S.RowLeft>
            </S.SkeletonRow>
          ))}
        </S.GroupList>
      </S.Group>
    ))}
  </div>
);

export default Skeleton;
